import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  color: ${({ fontColor }) => fontColor};
  background: ${({ backgroundColor }) => backgroundColor};
  font-size: inherit;
  font-weight: inherit;
`;

Container.propTypes = {
  fontColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

Container.defaultProps = {
  fontColor: 'inherit',
  backgroundColor: 'transparent',
};

export default Container;
